<template lang="pug">
.intro-slides
  .swiper-container(ref="swiper")
    .swiper-wrapper
      .swiper-slide(v-for="(ex, i) in $t('introduction.exhibits')" :key="i")
        zoom-card(:idx="i" :total="$t('introduction.exhibits').length" :progress="progress" :transitioning="transitioning")
          card-view(:active="activeCard === i" @clicked="onCardClick(i)" :content="ex")
    .swiper-pagination(ref="pagination")
  
</template>
<script>
import Swiper from 'swiper'
import ZoomCard from './ZoomCard'
import CardView from './CardView'
import { mapMutations } from 'vuex'
export default {
  name: 'IntroSlides',
  components: { CardView, ZoomCard },
  props: {
    activeCard: {
      default: -1,
    },
  },
  data() {
    return {
      progress: 0,
      transitioning: false,
    }
  },
  computed: {},
  methods: {
    ...mapMutations('app', ['setRouterBack']),
    onCardClick(i) {
      if (this.activeCard === i) {
        console.log(999)
        this.$router.replace('/introduction/intro')
        // this.setRouterBack('/')
      } else {
        // this.setRouterBack('/introduction/intro')
        this.$router.replace('/introduction/intro/' + i)
      }
    },
  },
  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      pagination: {
        el: this.$refs.pagination,
      },
      on: {
        progress: (swiper, p) => {
          console.log(p)
          this.progress = p
        },
        transitionStart: () => {
          // if (this.swiper)
          //   console.log('trans', this.swiper.wrapperEl.style.transitionDuration)
          this.transitioning = true
        },
        transitionEnd: () => {
          console.log('trans end')
          this.transitioning = false
        },
      },
    })
  },
}
</script>

<style scoped lang="sass">
@import "../../styles/common"
.intro-slides
  width: 100%
  .swiper-container
    width: 100%
    overflow: visible
    .swiper-slide
      //background: #42b983
      width: pxToRem(582)
      height: pxToRem(950)
    .swiper-pagination
      position: relative
      top: pxToRem(0)
</style>
